import { WebStorageStateStore } from "oidc-client-ts";
import { setupOidcClient } from "../auth/oidc/setup";

export function setupLinkClient(identityProviderUri, clientId, idpHint?: string) {
    let extraQueryParams = {};
    if (idpHint) {
        extraQueryParams = { kc_idp_hint: idpHint };
    }
    return setupOidcClient({
        identityProviderUri,
        clientId,
        appUri: `${window.location.origin}/`,
        redirectUri: `${window.location.origin}/auth`,
        postLogoutRedirectUri: `${window.location.origin}/`,
        responseType: "code",
        scopes: ["openid", "profile", "email", "offline_access"],
        signInRedirectParams: {
            state: {
                finalRedirectUri: window.location.href,
            },
        },
        userStore: new WebStorageStateStore({ store: window.localStorage }),
        extraQueryParams: extraQueryParams,
        // logLevel: "error",
    });
}
